import img1 from "../assets/gallery/Balkans/Balkans-2023-1.jpg";
import img2 from "../assets/gallery/Balkans/Balkans-2023-2.jpg";
import img3 from "../assets/gallery/Balkans/Balkans-2023-3.jpg";
import img4 from "../assets/gallery/Balkans/Balkans-2023-4.jpg";
import img5 from "../assets/gallery/Balkans/Balkans-2023-5.jpg";
import img6 from "../assets/gallery/Balkans/Balkans-2023-6.jpg";
import img7 from "../assets/gallery/Balkans/Balkans-2023-7.jpg";
import img8 from "../assets/gallery/Balkans/Balkans-2023-8.jpg";
import img9 from "../assets/gallery/Balkans/Balkans-2023-9.jpg";
import img10 from "../assets/gallery/Balkans/Balkans-2023-10.jpg";
import img11 from "../assets/gallery/Balkans/Balkans-2023-11.jpg";
import img12 from "../assets/gallery/Balkans/Balkans-2023-12.jpg";

const balkansGallery = [
  { img: img1, rowSpan: 2 }, // tall left
  { img: img2 }, // small top middle
  { img: img3 }, // small top right

  { img: img4 }, // small
  { img: img5 }, // small
  { img: img6, rowSpan: 2 }, // tall right

  { img: img7, colSpan: 2 }, // wide image

  { img: img8 }, // small
  { img: img9, rowSpan: 2 }, // tall

  { img: img10 }, // small
  { img: img11 }, // small
  { img: img12 }, // small
];

export default balkansGallery;
